import React from "react";
import {Navigate, useRoutes} from "react-router";
import ListOfIntCollRequests from "../features/collection-requests/ListOfIntCollRequests";
import IcrPage from "../features/collection-requests/IcrPage";
import EeiPage from "../features/collection-requests/EeiPage";
import GapPage from "../features/collection-requests/GapPage";
import AppCollector from "../apps/collector/appCollector";
import {ReportPageLayout} from "../features/products/reportPage";
import ReportEditorPage from "../features/products/reportEditorPage/ReportEditorPage";
import ReportMentionsPage from "../features/products/reportMentionsPage/ReportMentionsPage";
import ReportPreviewPage from "../features/products/previewPage/ReportPreviewPage";
import {routesChat} from "./routesChat";
import FeedsPage from "../features/chat/feeds/FeedsPage";
import FeedItems from "../features/chat/feeds/components/FeedItems";
import ReadbookPage from "../apps/policymaker/pages/readbooks/ReadbookPage";
import AllProductsPage from "../features/products/pages/AllProductsPage";
import KnowledgeBasePage from "../features/knowledgeBase/KnowledgeBasePage";
import EntitiesList from "../features/knowledgeBase/EntitiesList";
import EntityDetailPage from "../features/knowledgeBase/EntityDetailPage";
import WhiteboardsListPage from "../features/whiteboards/WhiteboardsListPage";
import WhiteboardPage from "../features/whiteboards/WhiteboardPage";
import ListOfExperts from "../features/experts/ListOfExperts";
import ExpertPage from "../features/experts/ExpertPage";
import HelpPage from "../features/help/HelpPage";
import WorkflowPage from "../features/workflow/WorkflowPage";
import LegacyRfiRedirect from "./LegacyRfiRedirect";
import LegacyWhiteboardRedirect from "./LegacyWhiteboardRedirect";
import TagBrowsePage from "../features/collection-requests/tags/TagBrowsePage";
import {collectionChildRoutes} from "./collectionRoutes";

const routesCollector = [
    ...routesChat,
    {
        path: "/",
        element: <AppCollector/>,
        children: [
            {index: true, element: <Navigate to="/icr" replace/>},
            {path: "/icr/eei/:eeiNumber", element: <EeiPage/>},
            {path: "/icr/gap/:gapNumber", element: <GapPage/>},
            {path: "/icr/:icrNumber", element: <IcrPage/>},
            {path: "/icr", element: <ListOfIntCollRequests/>},
            {path: "/tags/:tag", element: <TagBrowsePage/>},
            {path: "/rfi", element: <Navigate to="/icr" replace/>},
            {path: "/rfi/*", element: <LegacyRfiRedirect/>},
            ...collectionChildRoutes,
            {path: "products", element: <AllProductsPage/>},
            {path: "charts", element: <WhiteboardsListPage/>},
            {path: "help", element: <HelpPage/>},
            {path: "workflow", element: <WorkflowPage/>},
            {
                path: "kb",
                element: <KnowledgeBasePage/>,
                children: [
                    {index: true, element: <EntitiesList/>},
                    {path: ":entityId", element: <EntityDetailPage/>},
                ],
            },
            {
                path: "feed",
                element: <FeedsPage/>,
                children: [
                    {
                        path: ":feedId", element: <FeedItems/>,
                        children: [
                            {path: ":sourceSegmentId", element: <ReadbookPage/>},
                        ],
                    },],
            },
            {path: "experts", element: <ListOfExperts/>},
            {path: "experts/:handle", element: <ExpertPage/>},
        ],
    },
    {
        path: "/products/:reportId",
        element: <ReportPageLayout/>,
        children: [
            {path: "edit", element: <ReportEditorPage/>},
            {path: "mentions", element: <ReportMentionsPage/>},
            {path: "preview", element: <ReportPreviewPage/>},
            {path: "preview/:version", element: <ReportPreviewPage/>},
        ],
    },
    {
        path: "/charts/:whiteboardId",
        element: <WhiteboardPage/>,
    },
    {path: "/whiteboards", element: <Navigate to="/charts" replace/>},
    {path: "/whiteboards/*", element: <LegacyWhiteboardRedirect/>},
    {path: "*", element: <Navigate to="/icr" replace/>},
];

export function RoutesCollector() {
    return useRoutes(routesCollector);
}
